import { BookOpen } from 'lucide-react'

export function AuthBrand() {
  return (
    <div className="hidden lg:flex lg:w-1/2 flex-col justify-between bg-sidebar p-12 text-sidebar-foreground">
      {/* Logo */}
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary">
          <BookOpen className="h-5 w-5 text-white" />
        </div>
        <span className="text-lg font-bold">Uyendo</span>
      </div>

      {/* Main content */}
      <div className="space-y-6">
        <blockquote className="space-y-4">
          <p className="text-3xl font-semibold leading-tight">
            Join a community of{' '}
            <span className="text-primary">99,000+</span>{' '}
            Creator Educators
          </p>
          <p className="text-sm text-sidebar-foreground/70 leading-relaxed max-w-sm">
            Your 14-day free trial starts now. Comprehensive LMS features for modern educators and learners.
          </p>
        </blockquote>

        {/* Social proof */}
        <div className="flex items-center gap-4">
          <div className="flex -space-x-2">
            {['T', 'J', 'A', 'M'].map((initial, i) => (
              <div
                key={i}
                className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-sidebar bg-primary text-xs font-medium text-white"
              >
                {initial}
              </div>
            ))}
          </div>
          <p className="text-xs text-sidebar-foreground/60">
            Trusted by educators worldwide
          </p>
        </div>
      </div>

      {/* Footer */}
      <p className="text-xs text-sidebar-foreground/40">
        © 2025 Uyendo LMS. All rights reserved.
      </p>
    </div>
  )
}
